import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {
    ControlroomAckGQL, ControlroomCreateTicketGQL
} from '../../graphql';

import { map } from 'rxjs/operators';
import { UserProfileService } from 'app/shared/user-profile/user-profile.service';

@Injectable({
    providedIn: 'root'
})
export class AcknowledgmentTicketsService {

    constructor(
        private apollo: Apollo,
        private userProfileService: UserProfileService,
        private controlroomAckGQL: ControlroomAckGQL,
        private controlroomCreateTicketGQL: ControlroomCreateTicketGQL
    ) {
    }

    public acknowledgeAlarm(turbineCode: string, alarmId: string) {
        const profile = this.userProfileService.getUserProfile();
        const userName = (profile?.firstName || profile?.lastName) ? profile.firstName + ' ' + profile.lastName : 'undefined';
        const userEmail = profile?.email || '';

        return this.apollo.mutate({
            mutation: this.controlroomAckGQL.document,
            variables: { userName, userEmail, turbineCode, _id_alarm: alarmId }
        }).pipe(map((data: any) => data));
    }

    public createTicket(alarmData: any) {
    const profile = this.userProfileService.getUserProfile();

    const vars: any = {
        _id_alarm: alarmData.id_alarm || alarmData._id_alarm,
        alarmCategory:
        alarmData.categoryLabel === 'LIMITED_OP' ? 1 :
        alarmData.categoryLabel === 'MAINTENANCE' ? 2 :
        alarmData.categoryLabel === 'NO_DATA' ? 99 : 3,
        code: alarmData.code,
        turbineCode: alarmData.turbine,
        description: alarmData.description,
        createTS: alarmData.start,
        isOpen: alarmData.isOpen,
        userEmail: profile?.email || '',
        userName: ((profile?.firstName || profile?.lastName)
        ? `${profile?.firstName ?? ''} ${profile?.lastName ?? ''}`.trim()
        : 'undefined'),
        turbineStatus:
        alarmData.turbineMappedStatus === 1 ? 'Stop' :
        alarmData.turbineMappedStatus === 2 ? 'Running' : 'No data'
    };

    return this.apollo.mutate({
        mutation: this.controlroomCreateTicketGQL.document,
        variables: vars
    }).pipe(map((data: any) => data));
    }


}
